module.exports = __webpack_public_path__ + "static/media/sms.520a1077.svg";